import { Skeleton } from "@mui/material";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

const ChatMessageSkeleton: FC<Props> = () => {
  return (
    <div className={styles.card}>
      <Skeleton variant="text" sx={{ width: "20%", fontSize: "14px" }} />
      <Skeleton variant="text" sx={{ width: "80%", fontSize: "14px" }} />
    </div>
  );
};

export default ChatMessageSkeleton;
